import React from "react";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import { Link } from "../../lib/Link";

export class ItemSelector extends React.Component {
  state = { updateId: 1 };
  selected = {};
  constructor(props) {
    super(props);
    this.state = this.getState(props);
    console.log(this.state);
  }
  getState(props) {
    this.selected = {};
    if (props.value) {
      props.value.forEach(item => {
        this.selected[item] = true;
      });
    }
    this.optionMap = {};
    for (const option of props.options) {
      this.optionMap[option[props.idField]] = option;
    }
    return { updateId: this.state.updateId + 1 };
  }
  componentWillReceiveProps(newProps) {
    this.setState(this.getState(newProps));
  }
  onCheck(slug, checked) {
    if (checked) {
      this.selected[slug] = true;
    } else {
      delete this.selected[slug];
    }
    // keyは、stringになってしまっているので、本来のデータ型に戻す
    const selectedKeys = Object.keys(this.selected)
      .map(id => this.optionMap[id] && this.optionMap[id][this.props.idField])
      .filter(item => item);
    this.props.onChangeValue(selectedKeys.length ? selectedKeys : null);
    this.setState({ updateId: this.state.updateId + 1 });
  }
  render() {
    return (
      <div>
        <div className="area_choice">
          {this.props.idField == "slug" && this.props.options &&
            this.props.options.map((option, index) => this.props.count[option[this.props.idField]] && (
              <div className = "line_choice">
              <Checkbox
                checked={this.selected[option[this.props.idField]]}
                value={`${option.name}(${this.props.count[option[this.props.idField]]})`}
                key={index}
                onChange={(event, element) =>
                  this.onCheck(option[this.props.idField], element.checked)
                }
              />
              <Link to={`/${this.props.pref.slug}/line-${option.slug}/`} className="line_link">
                {`${option.name}(${this.props.count[option[this.props.idField]]})`}
              </Link>
              </div>
            ))}
            {this.props.idField == "stationId" && this.props.options &&
            this.props.options.map((option, index) => this.props.count[option[this.props.idField]] && (
              <Checkbox
                checked={this.selected[option[this.props.idField]]}
                label={`${option.name}(${this.props.count[option[this.props.idField]]})`}
                key={index}
                onChange={(event, element) =>
                  this.onCheck(option[this.props.idField], element.checked)
                }
              />
            ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/ItemSelector.jsx